import React from "react";

const router = require("app/services/router");

export default class Terms extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            acceptedTerms: false
        };

    }

    get type() {
        return translate('betingelserne');
    }

    get urlToTerms() {
        return '#';
    }

    get checkboxId() {
        return 'termsCheckbox';
    }

    hasAccepted() {
        return this.state.acceptedTerms;
    }

    reset() {
        return this.setState({acceptedTerms: false});
    }

    /////////////////////////////////
    // Events helpers
    /////////////////////////////////

    _onTermsStatusChange = (e) => {
        this.setState({acceptedTerms: e.target.checked}, () => {

            const {onChange} = this.props;

            if (typeof onChange === 'function') {
                onChange(this.state.acceptedTerms);
            }
        });
    };

    /////////////////////////////////
    // Rendering helpers
    /////////////////////////////////

    renderLabel() {

        const contents = this.renderLabelContents();

        if(!contents) {
            return null;
        }

        return (
            <label htmlFor={this.checkboxId}>
                {contents}
            </label>
        );
    }

    renderLabelContents() {
        return null;
    }

    renderTerms() {
        return null
    }

    render() {
        return (
            <div className={["field checkbox-field", this.props.className || null].join(' ')}>
                <input id={this.checkboxId} type="checkbox" checked={this.state.acceptedTerms}
                       onChange={this._onTermsStatusChange}/>
                {this.renderLabel()}
                {this.renderTerms()}
            </div>
        );
    }

}
